<template>
  <div>
    <h2 class="text-center font-weight-light">
      Nhập thông tin từ tập tin
    </h2>
    <v-alert
      dense
      text
      type="info"
      icon="mdi-lightbulb-on-outline"
      dismissible
      class="mt-4"
    >
      <strong>Gợi ý: </strong>
      {{ $vuetify.lang.t('$vuetify.msg.getFileSampe') }}
    </v-alert>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <!-- <v-text-field
              v-model="date"
              label="Ngày niêm yết"
              class="require"
              placeholder="dd/mm/yyyy"
              v-mask="'##/##/####'"
              autofocus
              filled
              prepend-icon="mdi-calendar"
              clearable
              hide-details
            /> -->
            <DatePickerDialog
              v-model="date"
              :label="'Ngày niêm yết'"
              :filled="true"
              :hideDetails="true"
            ></DatePickerDialog>
          </v-col>
          <v-col cols="12">
            <v-file-input
              v-model="file"
              ref="fileInput"
              label="Chọn file Excel"
              class="require"
              filled
              prepend-icon="mdi-microsoft-excel"
              autofocus
              messages="Lưu ý: Chỉ chấp nhận tập tin dạng: *.xls, *.xlsx"
            />
          </v-col>
          <v-col cols="12" v-if="errors_exist">
            <v-alert
              dense
              outlined
              type="error"
              dismissible
            >
              {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
              <ul>
                <div v-for="(error, index) in errors">
                  <li :key="index">{{ error[0] }}</li>
                </div>
              </ul>
            </v-alert>
          </v-col>
        </v-row>
        <div 
          v-if="loading"
          class="text-center" 
        >
          <v-progress-circular
            indeterminate
            size="50"
          />
        </div>
        <v-simple-table
          v-if="items.length || items_err.length"
          fixed-header
          height="300px"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th>Mặt hàng</th>
                <th>Giá thấp</th>
                <th>Giá cao</th>
                <th>Trạng thái</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item_err in items_err"
                style="background: #fff1e1;"
              >
                <td>{{ item_err.mathang_name }}</td>
                <td>{{ item_err.l_price | currency }}</td>
                <td>{{ item_err.h_price | currency }}</td>
                <td>Mặt hàng không có</td>
              </tr>
              <tr
                v-for="(item, index) in items"
                :key="index"
              >
                <td>{{ item.mathang_name }}</td>
                <td>{{ item.l_price | currency }}</td>
                <td>{{ item.h_price | currency }}</td>
                <td>Sẵn sàng import</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-btn
              :loading="spin"
              class="mr-2"
              @click="getTemplate"
              dark
              color="blue"
              block
            >Lấy file mẫu</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-btn 
              class="mr-2"
              @click="reset"
              dark
              color="teal"
              block
            >Làm mới</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-btn 
              class="mr-2" 
              :disabled="!file || !date"
              @click="importData(true)"
              color="accent"
              block
            >Xem trước dữ liệu</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-btn 
              :disabled="!file || !date"
              @click="importData(false)"
              color="success"
              block
            >Import ngay</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  import FileSevice from '@/services/File';
  import DatePickerDialog from '@/components/common/DatePickerDialog.vue';
  export default {
    components: {
      DatePickerDialog
    },
    data () {
      return {
        loading: false,
        spin: false,
        errors_exist: false,
        errors: [],
        file: null,
        date: '',
        headers: [
          { text: 'Mặt hàng', value: 'mathang_name' },
          { text: 'Giá thấp', value: 'l_price' },
          { text: 'Giá cao', value: 'h_price' }
        ],
        items: [],
        items_err: []
      }
    },
    watch: {
      file(){
        this.items=[];
        this.items_err=[];
      }
    },
    mounted(){
      let n = new Date();
      let d = n.getDate();
      let m = n.getMonth() + 1;
      let y = n.getFullYear();
      this.date = `${( d<10 ? `0${d}` : d )}/${( m<10 ? `0${m}` : m )}/${y}`;
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getTemplate(){
        const app =this;
        app.spin=true;
        axios.get(
          'api/v1/market-import-template',
          {responseType: 'arraybuffer'}
        )
          .then(function (response) {
            FileSevice.download(response.data, `market.xlsx`);
            app.spin=false;
            app.openSnackbar({ 
              type: 'success',
              body: 'Lấy mẫu thành công!'
            });
          })
          .catch(function (error) {
            app.spin=false;
            app.openSnackbar({ type: 'success' });
          });
      },
      reset(){
        this.file=null;
        this.items=[];
        this.items_err=[];
      },
      importData(preview) {
        const app = this;
        app.loading=true;
        const file = app.file;
        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };
        let formData = new FormData();
        formData.append('date', app.date);
        formData.append('preview', preview);
        formData.append('import_file', file);
        axios.post(
          'api/v1/market-import', 
          formData, 
          config
        )
          .then(function (response) {
            app.items=[];
            app.items_err=[];
            if(preview) {
              app.items = response.data.datas;
              app.items_err = response.data.datas_err;
            }
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          })
          .catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>
<style scoped>
.err-table {
  background-color: #fb8c00;
}
</style>